module.exports = __webpack_public_path__ + "static/media/blingV3_9.419c89ac.png";